import { Typography } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../Translations';
import { participantSearchStore } from '../Stores/ParticipantSearchStore';

const GroupsTable: React.FC = () => {
  const groups = participantSearchStore.groups;
  const selectedGroupIds = participantSearchStore.selectedGroupIds;
  const pinnedGroupIds = participantSearchStore.pinnedGroupIds;

  const allSelected = groups.length > 0 && groups.every((group) => selectedGroupIds.has(group.id));
  const someSelected = groups.some((group) => selectedGroupIds.has(group.id)) && !allSelected;

  return (
    <div>
      <Typography variant="bodyMedium" className="text-muted-foreground mb-4">
        <T
          kind="Viewing {{resultsCount}} of {{totalCount}} groups"
          resultsCount={groups.length}
          totalCount={groups.length}
        />
        {selectedGroupIds.size > 0 && (
          <>
            {' '}
            <T kind="({{count}} selected)" count={selectedGroupIds.size} />
          </>
        )}
      </Typography>

      <div
        className="border border-border rounded-lg overflow-hidden"
        data-intercom-target="participant-search-groups-table"
      >
        <table className="w-full">
          <thead className="bg-muted">
            <tr>
              <th className="w-12 px-4 py-3 text-left">
                <input
                  type="checkbox"
                  className="w-5 h-5 rounded cursor-pointer text-primary border-border focus:ring-primary"
                  checked={allSelected}
                  ref={(input) => {
                    if (input) {
                      input.indeterminate = someSelected;
                    }
                  }}
                  onChange={() => participantSearchStore.toggleAllGroups()}
                />
              </th>
              <th className="px-4 py-3 text-left">
                <Typography
                  variant="caption"
                  fontWeight="semibold"
                  className="text-muted-foreground"
                >
                  <T kind="Group Name" />
                </Typography>
              </th>
            </tr>
          </thead>
          <tbody className="bg-card divide-y divide-border">
            {groups.length === 0 ? (
              <tr>
                <td colSpan={2} className="px-4 py-8 text-center">
                  <Typography variant="bodyMedium" as="span" className="text-muted-foreground">
                    <T kind="No groups found" />
                  </Typography>
                </td>
              </tr>
            ) : (
              groups.map((group) => {
                const isPinned = pinnedGroupIds.has(group.id);
                return (
                  <tr key={group.id} className={clsx({ 'bg-primary/10': isPinned })}>
                    <td className="px-4 py-4">
                      <input
                        type="checkbox"
                        className="w-5 h-5 rounded cursor-pointer text-primary border-border focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50"
                        checked={selectedGroupIds.has(group.id)}
                        onChange={() => participantSearchStore.toggleGroupSelection(group.id)}
                      />
                    </td>
                    <td className="px-4 py-4">
                      <Typography variant="bodyMedium" as="span" className="text-primary">
                        {group.name}
                      </Typography>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default observer(GroupsTable);
